import { render, staticRenderFns } from "./AddPlot.vue?vue&type=template&id=6c2ddcc2"
import script from "./AddPlot.vue?vue&type=script&lang=js"
export * from "./AddPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports